export const serviceReservationNotificationTemplate = `<div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
        <strong>Service</strong>
    </p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{services}}</p>
</div>
<div style="margin: 0; padding-top: 10px; padding-bottom: 10px">
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333; padding-top: 10px">
        <strong>Mitarbeiter</strong>
    </p>
    <p style="margin: 0; font-size: 14px; line-height: 21px; color: #333333">{{employee}}</p>
</div>`
